export interface AISearchOptionConfig {
  id: string;
  label: string;
  iconName: 'chevronLeft' | 'search' | 'informationCircle' | 'zap';
  href?: string;
  actionType?: 'exit';
}

export const AI_SEARCH_OPTIONS: AISearchOptionConfig[] = [
  {
    id: 'exit',
    label: 'Exit Conversational Search',
    iconName: 'chevronLeft',
    actionType: 'exit',
  },
  // todo (DSS-3768): add actions to these buttons
  {
    id: 'what',
    label: 'What can I search for?',
    iconName: 'search',
    href: '#',
  },
  {
    id: 'how',
    label: 'How does it work?',
    iconName: 'informationCircle',
    href: '#',
  },
  {
    id: 'why',
    label: 'Why is it faster?',
    iconName: 'zap',
    href: '#',
  },
];
